<template>
  <div id='wrapper'>
    <div id='horizontal-align'>
      <div id='vertical-align'>
        <transition name="fade">
          <div v-show="!scrolled2" id='container'>
            <h1>Mt.</h1>
            <p id=name>Markus Tinnfält</p>
            <p id=job-title>Software developer</p>
          </div>
        </transition>
      </div>
      <transition name="fade">
        <div v-show="!scrolled" id='arrow'><i class="fas fa-chevron-down"></i></div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TitlePanel',
  data: () => {
    return {
      scrolled: false,
      scrolled2: false
    }
  },
  methods: {
    handleScroll () {
      this.scrolled = window.scrollY > 0,
      this.scrolled2 = window.scrollY > 400
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style scoped>

@keyframes bounce {
  0% {bottom: 10px;}
  50% {bottom: 30px;}
  100% {bottom: 10px;}
}

i {
  cursor: none;
  font-size: 2rem;
}

#arrow {
  color: white;
  position: absolute;
  font-size: 3rem;
  animation: bounce 3s infinite;
}

#wrapper {
  height: 100vh;
}

#horizontal-align {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
}

#vertical-align {
  height: 100vh;
  display: flex;
  padding: 1rem;
  align-items: center;
}

#container {
  color: white;
}

#name {
  margin: 10px;
  color: orchid;
}

#job-title {
  margin: 5px;
  font-size: 1.5rem;
  font-family: 'Source Code Pro', monospace;
}

h1 {
  font-size: 10rem;
  margin: 1rem;
  font-weight: normal;
}

p {
  font-size: 2rem;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}



</style>